module.exports = __webpack_public_path__ + "img/image02.f22a6d41.jpg";